import * as types from '../actions/types'
import Immutable from 'immutable'
import moment from 'moment'


import {
    isPrimitive, proveedor
} from '../utils/helpers'

const thisYear = new Date().getFullYear()

const INITIAL_STATE = Immutable.fromJS({
    proyecto_evento: null,
    observaciones: null,
    fecha_inicio: moment(new Date(thisYear, 0, 1)).format('YYYY-MM-DD'),
    fecha_entrega: moment(new Date(thisYear, 11, 31)).format('YYYY-MM-DD'),
    proveedor: proveedor(),
    btnSaveDisabled: false,
    tipo_proveedor: 1,
    tipo: 2
})


export default function (state = INITIAL_STATE, action) {
    let data, index
	switch (action.type) {
        case types.REINICIAR_SOLICITUD_CONTRATOANUAL:
            return INITIAL_STATE
        case types.MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }

            if (action.payload.path == 'tipo_proveedor') { 
                if (action.payload.value == 2) {
                    state = state.set('proveedor', proveedor())
                }
            }


            if (action.payload.path == 'fecha_inicio') {
                const year = moment(action.payload.value).year()
                state = state.set('fecha_entrega', moment(new Date(year, 11, 31)).format('YYYY-MM-DD'))
            }

            return state

            
        case types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_CONTRATOANUAL:
            state = state.set('btnSaveDisabled', action.payload)
			return state
    	default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/creacioncontratoanual.js